import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation navigatorNoteSampleUpsert(
    $id: ID
    $attributes: NavigatorNoteSampleInput!
  ) {
    navigatorNoteSampleUpsert(id: $id, attributes: $attributes) {
      id
      note
      name
    }
  }
`

export default function useNavigatorNoteSampleUpsert() {
  const { onMutate: onNavigatorNoteSampleUpsert, loading } = useSafeRunMutation(
    {
      mutation,
      responsePath: 'navigatorNoteSampleUpsert',
      successMessage: ''
    }
  )
  return { onNavigatorNoteSampleUpsert, loading }
}
